import "./Loader.css";
import React from "react";
import truck from "../images/truck.gif"; // ✅ default import

const ScreenLoaderComponent = () => {
  return (
    <div className="loader">
      <img src={truck} alt="Loading Truck" />
    </div>
  );
};

export default ScreenLoaderComponent;
